import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Signup from "@afrihost/vue-signup";
import "@afrihost/vue-signup/dist/afrihost-signup.css";
import store from '../../../main/js/store'
import router from '../../../main/js/router'

Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
		libraries: 'places',
	},
});

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: -60,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
});

Sentry.init({
	dsn: 'https://c33b28441b5b48d4a0b95fdef7828477@sentry.sys.afrihost.com/14',
	integrations: [new Integrations.Vue({ Vue, attachProps: true })],
	environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
});

Vue.use(Signup, {
	store: store,
	storeKey: process.env.MIX_SIGNUP_PLUGIN_STORE_KEY,
	vendorScope: 'octotel_ignite',
	solutionTypes: ['composite_fibre'],
	upsellSolutionTypes: [],
	googleMapsKey: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
	pageRequestedFrom: process.env.MIX_SIGNUP_PLUGIN_PAGE_REQUESTED_FROM + "-promo",
	testSignup: process.env.MIX_SIGNUP_PLUGIN_TEST === "true",
	decoInStock: {
		twoPack: process.env.MIX_SIGNUP_PLUGIN_DECO_2_IN_STOCK === "true",
		threePack: process.env.MIX_SIGNUP_PLUGIN_DECO_3_IN_STOCK === "true",
	},
	fibreFreeze: false,
	signalUuid: process.env.MIX_SIGNAL_UUID
})


import HeaderSearch from "./HeaderSearch";

new Vue({
	el: '.search-bar',
	store,
	router,
	render: h => h(HeaderSearch)
});

new Vue({
	el: 'signup-modal',
});

new Vue({
	el: '.signup-bar',
})
